import { styled } from '@mui/material/styles';
import { Toolbar as MuiToolbar } from '@mui/material';

export const Toolbar = styled(MuiToolbar)(({ theme }) => ({
  background: theme.palette.common.white,
}));

export const LeftItems = styled('div')({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
});

export const RightItems = styled('div')({
  display: 'flex',
  alignItems: 'center',
});

export const Logo = styled('img')(() => ({
  width: '100%',
  maxWidth: '72px',
  height: 'auto',
  objectFit: 'contain',
}));

export const LogoButton = styled('button')(() => ({
  width: 'fit-content',
  height: 'auto',
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
}));
